import React from 'react';
import ClassNames from 'classnames';
import { KEY_VALUES } from '../utils';
var HeaderOptionItem = function HeaderOptionItem(props) {
  var _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    style = props.style,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$iconName = props.iconName,
    iconName = _props$iconName === void 0 ? '' : _props$iconName,
    onClick = props.onClick,
    _props$iconSlot = props.iconSlot,
    iconSlot = _props$iconSlot === void 0 ? 'start' : _props$iconSlot;
  var classes = ClassNames('ap-header-options-item', className, {
    'reverse': iconSlot === 'end',
    'has-icon': iconName,
    'has-label': label
  });
  var keyupEvent = function keyupEvent(event) {
    if (event.key !== KEY_VALUES.ENTER) {
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  return label || iconName ? /*#__PURE__*/React.createElement("div", {
    className: classes,
    style: style,
    tabIndex: 0,
    role: "button",
    onClick: onClick,
    onKeyUp: keyupEvent
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-header-options-icon-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "Appkit4-icon icon-" + iconName,
    "aria-hidden": label ? true : false,
    "aria-label": label ? '' : iconName
  })), label && /*#__PURE__*/React.createElement("span", {
    className: "ap-header-options-label"
  }, label)) : null;
};
export default HeaderOptionItem;